import { Dialog, Popover, Transition } from "@headlessui/react";
import React, { FC, Fragment, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import Pagination from "shared/Pagination/Pagination";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import WidgetTags from "./WidgetTags";
import WidgetCategories from "./WidgetCategories";
import WidgetPosts from "./WidgetPosts";
import Card3 from "./Card3";
import Checkbox from "./Checkbox";

import ButtonThird from "shared/Button/ButtonThird";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useNavigate } from "react-router-dom";
import { requestAPI } from "utils/api";
import FooterNav from "components_custom/FooterNav/FooterNav";
//import CardReview from "./CardReview";
import CardBasic from "./CardBasic";
import CardProduct from "./CardProduct";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";
import SigninForm from "components_custom/SigninForm/SigninForm";
import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";

import { communityCategory } from "types/communityCategory";
import { XMarkIcon } from "@heroicons/react/24/solid";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const Community: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const navigate = useNavigate();

	const {
		initData,
	} = useContext(GlobalDataContext);
	const {
		toast,
		modal,
	} = useContext(UIContext);

	const [datas, setDatas] = useState<any>({
		oList: [],
		list: []
	});

	const [list, setList] = useState<[]>([]);
	const [selectType, setSelectType] = useState<string>("");

	const tabs: any = communityCategory;
	const [tabActive, setTabActive] = useState<any>(communityCategory[0]);



	useEffect(() => {

		(async () => {
			const res: any = await requestAPI('GET', `v1/community`, null);

			//console.log(res.data.list);
			const _datas = {
				oList: res.data.list,
				list: res.data.list,
			};

			//setList(res.data.list);
			setDatas(_datas);


		})();
	}, []);

	useEffect(() => {
		console.log('!')
		updateData(datas);
	}, [tabActive]);

	const renderCard = (item: any, idx: number) => {
		//console.log(post);
		switch (item.type) {
			case "review":
			case "party":
			case "request":
			case "qna":
				return (
					<CardProduct
						key={item._id}
						className=""
						post={item}
						idx={idx}
					/>
				);

			default:
				return (
					<CardBasic
						key={item._id}
						className=""
						post={item}
						idx={idx}
					/>
				);

		}
	};

	const handlePost = () => {
		if (initData.token_info.permission_group === "guest") {

			modal({
				title: "로그인",
				contents: <SigninForm modalSw={true} />,
				buttons: []
			});

			return toast({
				type: 'warning',
				contents: '로그인이 필요해요'
			});
		}

		navigate('/community-post');

	};

	const updateData = (_data: any) => {

		const _datas: any = { ..._data };

		let newDatas = [];

		newDatas = fillterTab(_datas.oList, "type", tabActive.key);
		//newDatas = fillterTab(newDatas, "category", tabActive2.key);
		_datas.list = newDatas;

		setDatas(_datas);
	};

	const fillterTab = (_datas: any, key: string, value: string) => {

		let v: any = [];

		if (value === "all") {
			v = [..._datas];
		} else {
			_datas.forEach((item: any) => {
				console.log(`${item[key]} ${value}`)
				if (item[key] === value) {
					v.push(item);
				}
			});
		}

		return v;
	}

	//communityCategory

	const handleTagClick = (tag: string) => {

	}

	const emptyList = () => {
		return (
			<main className="grid h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					<p
						className="line-clamp-1 text-[0.95rem]"
						style={{ fontWeight: "600", color: "#282f33" }}
					>
						안내
					</p>
					<div
						className="mt-4  line-clamp-1 text-[0.95rem]"
						style={{ fontWeight: "600", color: "#282f33" }}
					>
						등록된 게시글이 없어요!
					</div>
				</div>
				<div className="h-[500px]" />
			</main>
		)
	}




	return (
		<>
			<BgGlassmorphism />
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-full bg-white !p-0 lg:w-[768px]`}>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">

						<div className="mt-5" />

						<div
							className={`nc-Section-Heading relative flex flex-col justify-between ${className}`}
						>
							<div
								className={`flex justify-between items-center`}
							>
								<h2 className={`flex text-xl md:text-2xl font-semibold`}>
									<div>
										커뮤니티
									</div>
								</h2>
								<ButtonPrimary
									className="!m-0 !pt-1 !pb-1 !pl-4 !pr-4"
									onClick={() => handlePost()}
								>
									글쓰기
								</ButtonPrimary>
							</div>

						</div>

						<div className="mt-5" />

						<div className="w-full pl-2 pr-2">
							<div className="relative">
								<div className="flex h-[50px] overflow-x-auto whitespace-nowrap space-x-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
									<button className="" onClick={() => setTabActive(communityCategory[0])}>
										<CommunityBadge
											className={`${tabActive.key === "all" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"all"}
											href={""}
											color={"blue"}
										/>
									</button>
									<button onClick={() => setTabActive(communityCategory[1])}>
										<CommunityBadge
											className={`${tabActive.key === "event" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"event"}
											href={""}
											color={"purple"}
										/>
									</button>
									<button onClick={() => setTabActive(communityCategory[2])}>
										<CommunityBadge
											className={`${tabActive.key === "review" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"review"}
											href={""}
											color={"blue"}
										/>
									</button>
									<button onClick={() => setTabActive(communityCategory[3])}>
										<CommunityBadge
											className={`${tabActive.key === "party" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"party"}
											href={""}
											color={"green"}
										/>
									</button>
									<button onClick={() => setTabActive(communityCategory[4])}>
										<CommunityBadge
											className={`${tabActive.key === "request" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"request"}
											href={""}
											color={"pink"}
										/>
									</button>
									{/* <button onClick={() => setTabActive(communityCategory[4])}>
										<CommunityBadge
											className={`${tabActive.key === "hotspot" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"hotspot"}
											href={""}
											color={"purple"}
										/>
									</button> */}
									<button onClick={() => setTabActive(communityCategory[5])}>
										<CommunityBadge
											className={`${tabActive.key === "qna" ? "ring-2 ring-inset ring-red-600" : ""}`}
											type={"qna"}
											href={""}
											color={"gray"}
										/>
									</button>
								</div>

							</div>
						</div>

						<div className="mt-5" />

						<div className={``}>
							{/* {list.map((item, idx) => {
									//console.log ("!!", item)
									return (
										
									);
								})} */}

							{tabActive.key === "event" && (
								TopBannerEvent()
							)}
							{tabActive.key === "review" && (
								TopBannerReview()
							)}
							{tabActive.key === "party" && (
								TopBannerParty()
							)}
							{tabActive.key === "request" && (
								TopBannerRequest()
							)}
							{tabActive.key === "qna" && (
								TopBannerQNA()
							)}

							{
								datas.list.length > 0
									?
									<div className="space-y-[10px]">
										{datas.list.map((item: any, idx: number) => (
											<>
												{renderCard(item, idx)}
												<div className="border-t border-gray mb-[10px]"></div>
											</>

										))}
										{datas.list.length < 5 ? <div className="h-[500px]" /> : <></>}
									</div>
									:
									emptyList()
							}
						</div>
					</div>

				</div>
				<FooterNav />
			</div>
		</>
	);
};

export default Community;

function TopBannerEvent () {
	return (
		<div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 mb-10">
			<p className="text-sm/6 text-gray-900">
				<span className="text-lg font-bold">올타</span>는 항상 라이더와 드라이버의 입장에서 투어상품을 고민하고 있으며, 보다 쉽게 글로벌 투어에 참여할 수 있도록 다양한 나라의 투어코스를 검증하여 상품으로 연결해드리고 있습니다. 이후로도 올타 회원들의 니즈를 충족하기 위한 다양한 이벤트와 의견을 수렴하고 있기에 언제든 문의 주시기바랍니다.
			</p>
		</div>
	)
}

function TopBannerReview() {
	return (
		<div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 mb-10">
			<p className="text-sm/6 text-gray-900">
				<span className="text-lg font-bold">올타</span>를 통해 체험하신 글로벌 투어후기를 고민만 하는 많은 분들에게 용기와 동기부여가 될 것입니다. 블로그 및 SNS, 유튜브등 생생 후기들의 링크를 걸어 주셔도 좋고 짧게 리뷰를 남겨 주시면 감사 하겠습니다.
			</p>
		</div>
	)
}

function TopBannerParty() {
	return (
		<div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 mb-10">
			<p className="text-sm/6 text-gray-900">
				<span className="text-lg font-bold">본</span> 해외여행은 항상 언제든 떠날 수 있지만 내지인들이 나와 같은 스케줄을 맞추기 참 어렵습니다. 혼자 떠나기엔 무섭고, 두려운데 누군가 나와 같은 성향의 멤버가 동행한다면 더할 나위가 없기에 이곳에서 같이 여정을 함께 할 투어멤버를 찾아보세요~
			</p>
		</div>
	)
}

function TopBannerRequest() {
	return (
		<div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 mb-10">
			<p className="text-sm/6 text-gray-900">
			<span className="text-lg font-bold">올타</span>는 기업단체 및 동호회, 혹은 그룹멤버들을 위해 별도로 투어를 진행합니다.
									모르는 사람들과 진행하는것 보다 우리끼리 즐기고 싶을때 원하는 투어상품과 날짜를 선택하시고, 인원을 문의 준다면 최소인원 6명 부터는
									단체로 그룹 투어가 가능합니다.
									게시판에 다음 예시와 같이 남겨 주시면 됩니다.
			</p>
		</div>
	)
}

function TopBannerQNA() {
	return (
		<div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 mb-10">
			<p className="text-sm/6 text-gray-900">
				국내 및 글로벌 투어 상품과 관련하여 궁금 한게 있으면 언제든 질문 남겨 주시면 관리자가 확인 후 바로 답변을 드립니다.
				투어 상품의 구체적인 질문은 해당 상품의 질문 게시판을 이용하시기 바랍니다.
				주문취소 수수료는 여행상품별 별도로 약관을 운영하고 있어 주문 예약전 필히 상품 및 취소 약관을 확인 부탁드립니다.
			</p>
		</div>
	)
}